import React, { Component } from 'react';
import SecondaryButton from '../../Component/SecondaryButton';
import './HowToDonatePage.scss';
import img from '../../Assets/image_1-min.jpg';
import img2 from '../../Assets/image_2-min.jpg';

class HowToDonatePage extends Component {
  render() {
    return (
      <article className="how-to-donate">
        <header className="row">
          <div className="col-md-10 col-md-offset-1 text-center">
            <h2 className="section-header">Wie kann ich spenden?</h2>
            <p>
              Für Menschen, die einem Kind einen Weihnachtswunsch erfüllen
              möchten, gibt es drei Möglichkeiten:
            </p>
          </div>
        </header>

        <section className="row" id="direct-wish-fulfillment-section">
          <div className="col-md-10 col-md-offset-1">
            <div className="row">
              <div className="col-md-12">
                <div className="circle-counter">
                  <span>1</span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 section-content text-center">
                <div className="subsection">
                  <h3>Direkte Wunscherfüllung</h3>
                  <p>
                    Wunsch aussuchen und allein oder im Bündnis mit
                    Freund*innen oder Großfamilie diesen Wunsch erfüllen, das
                    Geschenk einpacken und in der Lutherkirche abgeben. Falls
                    der Pate / die Patin einen Brief dazu schreiben möchte,
                    lautet der Absender "Helfer / Helferin des Christkindes an
                    der Lutherkirche".
                  </p>
                  <p>
                    Um den Kindern das Gefühl zu vermitteln, dass sie etwas wert
                    sind, sollen sie zu Weihnachten nichts Gebrauchtes bekommen
                    (z.B. Kleidung). Im Einzelfall, z.B. bei teuren Wünschen,
                    sind aber gebrauchte Geschenke ok – das steht dann
                    ausdrücklich dabei.
                  </p>
                </div>
                <div className="subsection">
                  <h3>Wichtig</h3>
                  <p style={{ fontWeight: 900 }}>
                    <b>Wer einen Wunsch übernimmt, muss ihn erfüllen! Geschenke,
                    die nicht fristgerecht bei uns abgegeben werden, sind eine
                    Katastrophe.<br /> Gebracht werden können die Geschenke mittwochs und donnertags von 16-19 Uhr ins Gemeindebüro der Lutherkirche, Martin-Luther-Platz 4, 50677 Köln (allerletzte Abgabemöglichkeit ist Donnerstag, 10.12.2026) 
                    </b>
                  </p>
                </div>
                <div className="subsection">
                  <p>
                    Es hilft uns sehr, wenn die Geschenke bereits eingepackt
                    sind. Auf dem eingepackten Geschenk muss der Name des Kindes
                    mit der jeweiligen Nummer stehen!
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 text-center">
                <div className="donatebutton">
                  <SecondaryButton title="WUNSCHLISTE" to="/list" size="lg" />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="row" id="donation-section">
          <div className="col-md-10 col-md-offset-1">
            <div className="row">
              <div className="col-md-12">
                <div className="circle-counter">
                  <span>2</span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 section-content text-center">
                <h3>Geldspende für einen bestimmten Wunsch</h3>
                <p>
                  Auch die Übernahme von Teilbeträgen ist möglich. Wer einen
                  größeren Wunsch, z.B. ein Fahrrad, einen Einkaufsgutschein
                  oder den jährlichen Musikunterricht eines Kindes nicht
                  komplett, aber mit einem Teilbetrag unterstützen will, kann
                  hier den gewünschten Betrag eintragen. Das System zeigt an,
                  wieviel Geld für die vollständige Wunscherfüllung noch
                  gebraucht wird.
                </p>
                <p>
                  Dazu in der Wunschliste einen Wunsch auswählen und auf der
                  folgenden Seite den gewünschten Betrag eingeben.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 text-center">
                <div className="donatebutton">
                  <SecondaryButton title="WUNSCHLISTE" to="/list" size="lg" />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="row" id="transfer-section">
          <div className="col-md-10 col-md-offset-1">
            <div className="row">
              <div className="col-md-12">
                <div className="circle-counter">
                  <span>3</span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 section-content text-center">
                <h3>Geldspende für die Aktion allgemein</h3>
                <p>
                  Wer größere Beträge oder ohne eine bestimmte Wunschauswahl für
                  die Aktion spenden will, kann dies ebenfalls. Jeder Geldbetrag
                  hilft uns, denn wir unterstützen die bedürftigen Familien
                  ganzjährig.
                </p>
                <p>
                  Bei Geldspenden bis 300€ genügt für die steuerliche Anerkennung
                  beim Finanzamt Ihr Buchungsbeleg. Eine Zuwendungsbestätigung
                  (Steuerbescheinigung) erhalten Sie für Spenden ab 300€. Für die
                  Ausstellung benötigen wir Ihre vollständige Anschrift, die Sie
                  bitte im Verwendungszweck des Überweisungsträgers angeben.
                </p>
              </div>
            </div>
            {<div className="row">
              <div className="col-sm-10 col-sm-offset-1 text-center">
                <div className="bank-account-data text-center">
                  <p>Sie können unter folgender Kontonummer spenden:</p>
                  <p>
                    <strong>Empfänger: <br />Südstadt-Leben e.V.</strong>
                  </p>
                  <p>
                    <strong style={{ whiteSpace: 'nowrap' }}>IBAN: DE43 3506 0190 1013 4760 86</strong>
                  </p>
                  <br />
                  <p>
                    Verwendungszweck: <br />
                    <strong>Weihnachtswunschaktion</strong>
                  </p>
                  <br />
                  <p>Bank für Kirche und Diakonie</p>
                </div>
              </div>
            </div>}
          </div>
        </section>

        <section className="col-md-10 col-md-offset-1 text-center">
          <h3> Für Rückfragen</h3>
          <p>
          Hans Mörtter (Pfarrer i.R.), <a href="mailto:hans.moertter@ekir.de">hans.moertter@ekir.de</a><br/>
          Moni Hagenmayer (Projektleitung), <a href="mailto:lutherkirche@suedstadt-leben-koeln.de">lutherkirche@suedstadt-leben-koeln.de</a><br/>
          </p>
        </section>

        <section className="text-center">
          <figure>
            <img src={img} className="img-responsive img-thumbnail" alt="" />
            <figcaption>
              <small>© Christkind Helfer Lutherkirche</small>
            </figcaption>
          </figure>
          <figure>
            <img src={img2} className="img-responsive img-thumbnail" alt="" />
            <figcaption>
              <small>© Christkind Helfer Lutherkirche</small>
            </figcaption>
          </figure>
        </section>
      </article>
    );
  }
}

export default HowToDonatePage;



// WEBPACK FOOTER //
// ./src/Containers/Pages/HowToDonatePage.js